<h2 mat-dialog-title>Mappa Area - <i>{{data.object.name}}</i></h2>
<hr>
<mat-dialog-content id="area-container">
    <!-- <div class="field-container">
            <mat-form-field appearance="fill">
                <mat-label>Nome*</mat-label>
                <input matInput type="text" formControlName="name">
            </mat-form-field>
        </div>
        <div class="field-container">
            <mat-form-field appearance="fill">
                <mat-label>Descrizione*</mat-label>
                <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="4"
                    cdkAutosizeMaxRows="4" formControlName="descr"></textarea>
            </mat-form-field>
        </div> -->
    <agm-map #AgmMap style="width: 420px; height: 420px;" (mapReady)="onMapReady($event)" [zoomControl]="true"
        [scrollwheel]="false" [streetViewControl]="false">
        <agm-data-layer [geoJson]="data.object.geoArea" [style]="styleFunc">
        </agm-data-layer>
    </agm-map>
</mat-dialog-content>
<hr>
<mat-dialog-actions id="action-div">
    <button mat-stroked-button (click)="closeCancelling()" type="button" cdkFocusInitial>Chiudi</button>
</mat-dialog-actions>